import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { CommonUtility, Tabs } from '../../../../utility';
import { RouteTabs } from '../../../../components';
import { FulfillmentTabActionsProvider } from '../../../../contexts/fulfillment-tab-actions';
import { SettingsFulfillmentToolbar } from '../../../../page-components/settings/settings-fulfillment-toolbar';
import { WaveRulesTab } from './wave-rules';
import { TotesTab } from './totes';
import { PalletsTab } from './pallets';
import { ToteFeedPopup, PalletFeedPopup } from '../../../../page-components';
import { EmailPickListTab } from './email-picklist';
import { PackingStationTab } from './packing-stations';

export function FulfillmentTab({ warehouseId }) {
  const [openTotePopup, setTotePopup] = useState(false);
  const [openPalletPopup, setPalletPopup] = useState(false);
  const [search, setSearch] = useState('');

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const currentTab = useMemo(() => {
    if (pathname) {
      return (
        CommonUtility.getSegmentByPosition(pathname, 4) ||
        Tabs.settingsTab.fulfillmentTabs.waveRules
      );
    }
    return Tabs.settingsTab.fulfillmentTabs.waveRules;
  }, [pathname]);

  const tabClicked = tabName => {
    navigate(`/app/settings/fulfillment/${tabName}`);
  };

  useEffect(() => {
    setSearch('');
  }, [currentTab]);

  const menus = [
    { text: 'Wave Rules', value: Tabs.settingsTab.fulfillmentTabs.waveRules },
    { text: 'Totes', value: Tabs.settingsTab.fulfillmentTabs.totes },
    { text: 'Pallets', value: Tabs.settingsTab.fulfillmentTabs.pallets },
    {
      text: 'Email Picklists',
      value: Tabs.settingsTab.fulfillmentTabs.emailPickList,
    },
    {
      text: 'Packing Stations',
      value: Tabs.settingsTab.fulfillmentTabs.packingStations,
    },
  ];

  return (
    <FulfillmentTabActionsProvider>
      <RouteTabs
        items={menus}
        activeKey={currentTab}
        onChange={tabClicked}
        showNavBorder
        tabBarExtraContent={
          <SettingsFulfillmentToolbar
            currentTab={currentTab}
            search={search}
            onSearchChange={setSearch}
            onBulkUploadTotes={() => setTotePopup(true)}
            onBulkUploadPallets={() => setPalletPopup(true)}
          />
        }
      />
      <Routes>
        <Route index element={<WaveRulesTab warehouseId={warehouseId} />} />
        <Route
          path={Tabs.settingsTab.fulfillmentTabs.waveRules}
          element={<WaveRulesTab warehouseId={warehouseId} />}
        />
        <Route
          path={Tabs.settingsTab.fulfillmentTabs.totes}
          element={<TotesTab search={search} warehouseId={warehouseId} />}
        />
        <Route
          path={Tabs.settingsTab.fulfillmentTabs.pallets}
          element={<PalletsTab search={search} warehouseId={warehouseId} />}
        />
        <Route
          path={Tabs.settingsTab.fulfillmentTabs.emailPickList}
          element={<EmailPickListTab warehouseId={warehouseId} />}
        />
        <Route
          path={Tabs.settingsTab.fulfillmentTabs.packingStations}
          element={<PackingStationTab warehouseId={warehouseId} />}
        />
      </Routes>
      <ToteFeedPopup
        warehouseId={warehouseId}
        open={openTotePopup}
        onClose={() => setTotePopup(false)}
      />
      <PalletFeedPopup
        warehouseId={warehouseId}
        open={openPalletPopup}
        onClose={() => setPalletPopup(false)}
      />
    </FulfillmentTabActionsProvider>
  );
}
